/* global axios */
import ApiClient from './ApiClient';

class CallRecordsAPI extends ApiClient {
  constructor() {
    super('call_records', { accountScoped: true });
  }

  listPending({ perPage = 50 } = {}) {
    return axios.get(`${this.url}?pending_only=true&per_page=${perPage}`);
  }

  findByProviderCallId(providerCallId) {
    return axios.get(
      `${this.url}?provider_call_id=${encodeURIComponent(providerCallId)}&per_page=1`
    );
  }

  show(id) {
    return axios.get(`${this.url}/${id}`);
  }

  saveDisposition(id, payload) {
    return axios.patch(`${this.url}/${id}`, { call_record: payload });
  }

  // Phase 8: listagem com filtros + paginação
  list(filters = {}, { page = 1, perPage = 25 } = {}) {
    const params = new URLSearchParams();
    Object.entries(filters).forEach(([k, v]) => {
      if (v !== null && v !== undefined && v !== '') params.append(k, v);
    });
    params.append('page', page);
    params.append('per_page', perPage);
    return axios.get(`${this.url}?${params.toString()}`);
  }

  metrics(filters = {}) {
    const params = new URLSearchParams();
    Object.entries(filters).forEach(([k, v]) => {
      if (v !== null && v !== undefined && v !== '') params.append(k, v);
    });
    return axios.get(`${this.url}/metrics?${params.toString()}`);
  }

  diarize(id) {
    return axios.post(`${this.url}/${id}/diarize`);
  }

  transcribe(id) {
    return axios.post(`${this.url}/${id}/transcribe`);
  }

  score(id) {
    return axios.post(`${this.url}/${id}/score`);
  }

  // v64 #5 — enfileira ScoreCallJob pra múltiplos records de uma vez.
  // Backend limita a 200 ids por request.
  bulkScore(ids) {
    return axios.post(`${this.url}/bulk_score`, { ids });
  }

  // Phase 2.5 C — gera resumo AI da transcricao.
  // Retorna cache se ja tem summary, force=true regenera.
  summarize(id, { force = false } = {}) {
    return axios.post(`${this.url}/${id}/summarize`, { force });
  }

  // StackZap browser recording → multipart ActiveStorage on CallRecord.
  uploadRecording(id, blob, filename = 'call-recording.webm') {
    const formData = new FormData();
    formData.append('recording', blob, filename);
    return axios.post(`${this.url}/${id}/upload_recording`, formData);
  }
}

export default new CallRecordsAPI();
